package ru.villawonka.app.data.di

import io.ktor.client.HttpClient
import io.ktor.client.plugins.HttpSend
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.plugins.defaultRequest
import io.ktor.client.plugins.plugin
import io.ktor.http.ContentType
import io.ktor.http.contentType
import io.ktor.serialization.kotlinx.json.json
import kotlinx.serialization.json.Json
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.bind
import org.koin.dsl.module
import ru.villawonka.app.data.interceptor.installAuthInterceptor
import ru.villawonka.app.data.repository.PostsRepositoryImpl
import ru.villawonka.app.data.repository.AuthRepository
import ru.villawonka.app.data.repository.UserRepositoryImpl
import ru.villawonka.app.data.service.UserSettingsServiceImpl
import ru.villawonka.app.data.source.AuthApi
import ru.villawonka.app.data.source.PostsApi
import ru.villawonka.app.data.source.UserApi
import ru.villawonka.app.domain.repository.PostsRepository
import ru.villawonka.app.domain.repository.UserRepository
import ru.villawonka.app.domain.service.UserSettingsService

val dataModule = module {
    single<HttpClient> {
        HttpClient {
            install(ContentNegotiation) {
                json(Json {
                    ignoreUnknownKeys = true
                })
            }
            defaultRequest {
                contentType(ContentType.Application.Json)
            }
        }.apply {
            plugin(HttpSend).installAuthInterceptor(get())
        }
    }

    singleOf(::AuthApi)
    singleOf(::UserApi)
    singleOf(::PostsApi)

    singleOf(::AuthRepository)
    singleOf(::UserRepositoryImpl) bind UserRepository::class
    singleOf(::PostsRepositoryImpl) bind PostsRepository::class

    singleOf(::UserSettingsServiceImpl) bind UserSettingsService::class
}